module.exports = __webpack_public_path__ + "static/cna-news-d16028d60872a7e0a707bb8754ad202a.png";